import * as distributor from '../actionTypes/Distributor/Distributor'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'

function getDistributorSuccess (distributors) {
  return {
    type: distributor.GET_DISTRIBUTORS,
    distributors: distributors
  }
}

export const getDistributorList = () => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getDistributor
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let distributor = data.data[0]
      dispatch(getDistributorSuccess(distributor))
    })
  }
}

export const getDistributors = (callback) => {
  let distributorData = []
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getDistributors

  return (dispatch, getState) => {
    const state = getState()

    if (state.distributor.searchParams) {
      url = url + '?' + 'criteria=' + (state.distributor.searchParams.criteria ? encodeURIComponent(state.distributor.searchParams.criteria) : '')
    }

    if (state.distributor.sortParams) {
      url = url + '&sortBy=' + (state.distributor.sortParams.sortBy ? state.distributor.sortParams.sortBy : '') + '&sortType=' + (state.distributor.sortParams.sortType ? state.distributor.sortParams.sortType : '')
    }

    if (state.distributor.paginationParams && (state.distributor.searchParams.criteria === null || state.distributor.searchParams.criteria === '')) {
      url = url + '&psize=' + state.distributor.paginationParams.pageSize + '&pno=' + state.distributor.paginationParams.pageNumber
    } else {
      url = url + '&pno=0'
    }
    const api = new Api()
    api.getData(url, response => {
      distributorData = response
      dispatch(getDistributorSuccess(distributorData))
      callback()
    })
  }
}

export const sortUsers = (sortParams) => {
  return {
    type: distributor.SET_SORT_PARAMS_USERS,
    sortParams: sortParams
  }
}

export const paginationUsers = (paginationParams) => {
  return {
    type: distributor.SET_PAGINATION_PARAMS_USERS,
    paginationParams: paginationParams
  }
}

export const setSearchParams = (searchParams) => {
  return {
    type: distributor.SET_SEARCH_PARAMS_USERS,
    searchParams: searchParams
  }
}



// WEBPACK FOOTER //
// ./src/actions/distributor.js